import { render, staticRenderFns } from "./AbstractSignupTextInput.vue?vue&type=template&id=4fdc7cd5&scoped=true"
import script from "./AbstractSignupTextInput.vue?vue&type=script&lang=js"
export * from "./AbstractSignupTextInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fdc7cd5",
  null
  
)

export default component.exports